import Vue from 'vue'
import {Pagination, Input, Button} from 'element-ui'
Vue.use(Pagination);
Vue.use(Input);
Vue.use(Button);
